import React, {useState} from "react";
import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import useAntTable from "../../../../utils/useAntTable";
import * as categoryApi from "../../../../apis/productCategory";
import * as api from '../../../../apis/platforms/admin/contract'
import StandardTable, {StandardColumnsType} from "../../../../components/StandardTable";
import CategoryCascader from "../../../../components/CategoryCascader";
import {Button, Input, Space} from "antd";
import DictSelect from "../../../../components/DictSelect";
import {useRequest} from "ahooks";
import withAuth from "../../../../utils/withAuth";


const ExportButton = withAuth('export', Button);
export default function ContractPriceList() {

    const {tableProps, search, form, refresh, downloading, download} = useAntTable(api.getAllContractPrices, {downloadUrl: api.exportPrices})
    const [categories, setCategories] = useState([]);

    const {loading: loadingProductCategory} = useRequest(categoryApi.getCategoriesDict, {
        onSuccess(res) {
            setCategories(res.data.data);
        }
    });

    const columns:StandardColumnsType = [
        {
            title: '合同号',
            dataIndex: 'contractCode',

        },
        {
            title: '客户名称',
            dataIndex: 'dealerName',
        },
        {
            title: '终端医院',
            dataIndex: 'hospitalFullName',
        },
        {
            title: '集团',
            dataIndex: 'group'
        },
        {
            title: '产品线',
            dataIndex: 'categoryName',
            render: (value?: string) => value?.replace("//", '')?.replaceAll('/', ' / ')
        },
        {
            title: '商品编码',
            dataIndex: 'productCode'
        },
        {
            title: '规格型号',
            dataIndex: 'specification'
        },
        {
            title: '套餐',
            dataIndex: 'suitName'
        },
        {
            title: '商品名称',
            dataIndex: 'productName'
        },
        {
            title: '限购数量',
            dataIndex: 'restrictQty'
        },
        {
            title: '剩余数量',
            dataIndex: 'remainQty',
        },
        {
            title: '合同价格',
            dataIndex: 'price'
        }
    ]

    const extSearchColumns: StandardColumnsType = [
        {
            dataIndex: 'group',
            title: '集团',
            search: {
                colSpan: 8
            }
        },
        {
            dataIndex: 'dealerName',
            title: '客户名称',
            search: {
                colSpan: 8
            }
        },
        {
            dataIndex: 'code',
            title: '合同号',
            search: {
                colSpan: 8
            }
        },
        {
            dataIndex: 'productName',
            title: '商品名称',
            search: {
                valueRender() {
                    return <Input placeholder={'请输入商品名称'}/>
                },
                colSpan: 8
            }
        },
        {
            dataIndex: 'productCode',
            title: '商品编号',
            search: {
                valueRender() {
                    return <Input placeholder={'请输入商品编号'}/>
                },
                colSpan: 8
            }
        },
        {
            dataIndex: 'categoryId',
            title: '产品线',
            search: {
                valueRender() {
                    return <CategoryCascader options={categories} changeOnSelect
                                             fieldNames={{label: "name", children: "children", value: "id"}}/>
                },
                colSpan: 8
            }
        }
    ];

    const toolbar = (
        <Space>
            <ExportButton onClick={download} loading={downloading} type={"primary"}>导出</ExportButton>
        </Space>
    )

    return (
        <PageHeaderLayout>
            <StandardTable {...tableProps} columns={columns} rowKey={'id'} extSearchColumns={extSearchColumns}
                           search={search} form={form} toolbar={toolbar}/>
        </PageHeaderLayout>
    )
}
